import api from '@/api';
import { saveParamsToQuery } from '@/utils/helpers';

let currentTicketListRequest = null;

const lots = {
  namespaced: true,

  state() {
    return {
      isLoading: true,
      search: '',
      publicationDateStart: '',
      list: {
        lots: [],
        pageCount: 0,
        page: 0,
      },
    };
  },

  mutations: {
    setSearch(state, search) {
      state.search = search;
    },
    setPublicationDateStart(state, value) {
      state.publicationDateStart = value;
    },
    setPage(state, page) {
      state.list.page = page;
    },
    changeLoading(state, status) {
      state.isLoading = status;
    },
    setList(state, data) {
      state.list = { ...data };
    },
  },

  actions: {
    async setSearch({ commit, dispatch }, search) {
      commit('setSearch', search);
      commit('setPage', 1);
      await dispatch('loadList');
    },
    async setPage({ commit, dispatch }, page) {
      commit('setPage', page);
      await dispatch('loadList');
    },
    async loadList({
      state, commit, rootState, rootGetters,
    }) {
      commit('changeLoading', true);

      try {
        if (currentTicketListRequest) {
          return;
        }
        const { isLoggedIn } = rootState.user;
        const { filterType } = rootState.appService;
        const role = rootGetters['user/getPriorityRole']('gencontractor');

        if (!role && isLoggedIn) {
          return;
        }

        const params = {};

        // Формируем параметры запроса, удаляем пустые ключи фильтров
        Object.entries({
          page: state.list.page,
          name: state.search,
          publicationDateStart: state.publicationDateStart,
        }).forEach(([key, value]) => {
          if (typeof value === 'number') {
            params[key] = value;
            return;
          }
          if (typeof value === 'object' && value !== null && Object.keys(value).length) {
            params[key] = value;
            return;
          }
          if (value) {
            params[key] = value;
          }
        });
        params.pageSize = isLoggedIn ? 10 : 4;
        if (filterType) {
          params.type = filterType;
        }
        if (api.gencontractor[role] !== undefined) {
          currentTicketListRequest = api.gencontractor[role].list(params);
          const result = await currentTicketListRequest;

          saveParamsToQuery({ page: params.page, search: params.search });
          commit('setList', {
            ...result,
            lots: result.genContracts,
          });
          currentTicketListRequest = null;
        } else {
          commit('setList', { result: { lots: [], page: 1, pageCount: 1 } });
        }
      } catch (e) {
        currentTicketListRequest = null;
        console.log(e);
      } finally {
        commit('changeLoading', false);
      }
    },
  },
};

export default lots;
